import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { enrichFavouritesResponse } from '../helpers/Favourites';
import Favourite from '../records/Favourite';
import FavouritesActions from './FavouritesActions';
import FavouritesStore from '../stores/FavouritesStore';
import Railcard1617Actions from './Railcard1617Actions';

class FareHandOffActions {

    async getReorderable(query, user) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FARE_HANDOFF_LOADING,
        });

        try {
            let pending = [
                user.isLoggedIn() && Railcard1617Actions.load(user),
            ];

            let reorderable;
            if (query.reorder) {
                // Get the reorderable from the user's saved favourites
                await Promise.all([
                    ...pending,
                    FavouritesActions.getAll(user),
                ]);
                reorderable = FavouritesStore.getFavouriteById(Number(query.reorder));
            } else {
                // initialise the reorderable from individual query parameters
                [, reorderable] = await Promise.all([
                    ...pending,
                    getReorderableFromQuery(query, user)
                ]);
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.FARE_HANDOFF_LOADED,
                reorderable,
            });
        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.FARE_HANDOFF_LOAD_FAILED,
            });
            throw error;
        }
    }
}

// Construct a reorderable (Favourite) from query parameters
async function getReorderableFromQuery(query, user) {
    const isTrue = val => ['true', 'yes', '1'].includes(String(val).toLowerCase());
    const json = {
        origin: query.origin,
        destination: query.destination,
        adults: query.adults || 0,
        children: query.children || 0,
        route: query.route,
        ticketType: query.ticketType,
        smartTicketType: query.smartTicketType,
        railcards: query.railcards ? query.railcards.split(',') : null,
        isSeason: isTrue(query.isSeason),
        isSmartcard: isTrue(query.isSmartcard),
        isOpenReturn: isTrue(query.isOpenReturn),
        duration: query.duration,
    };

    const enriched = await enrichFavouritesResponse(json, user);
    return Favourite.fromJSON(enriched);
}

export default new FareHandOffActions();





// WEBPACK FOOTER //
// ./src/actions/FareHandOffActions.js